import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from 'primereact/checkbox';
import Translate from '../../../common/functions/translate';

const RegionList = (props) => {

  return (
    <DataTable
      value={props.regions}
      responsive
      paginator={true}
      lazy={true}
      rows={props.rows}
      rowsPerPageOptions={[10, 20, 50, 100]}
      totalRecords={props.totalRecords}
      onPage={(event) => props.onPageClick(event)}
      first={props.first}
      dataKey='regionId'
      selectionMode='single'
      onRowClick={(e) => props.editClick(e.data.id)}
    >
      <Column field="name" header={Translate("Name")} />
      <Column
        style={{ width: "8em" }}
        className='data-table-cell'
        field="isActive"
        header={Translate("Active")}
        body={(rowData, column) =>
          <>
            <Checkbox
              readOnly={true}
              disabled={true}
              checked={rowData.isActive}
              onChange={() => null}
            />
          </>
        }
      />
      <Column
        header={Translate("Actions")}
        style={{ width: "8em" }}
        className='data-table-cell'
        body={(rowData, column) =>
          <>
            <Button
              type="button"
              icon="pi pi-pencil"
              className="p-button-warning"
              tooltip={Translate("Edit")}
              tooltipOptions={{ position: 'top' }}
              style={{ marginRight: ".5em" }}
              onClick={() => props.editClick(rowData.id)}
            />
            <Button
              type="button"
              icon="pi pi-trash"
              className="p-button-danger"
              tooltip={Translate("Delete")}
              tooltipOptions={{ position: 'top' }}
              onClick={(e) => props.deleteClick(rowData.id, e)}
            />
          </>
        }
      />
    </DataTable>
  )
}

export default RegionList;
